module.exports = __webpack_public_path__ + "img/szimi-bence.399fd868.jpg";